import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";

export const getDropdownList = (level, params, searchParam) =>
    level === "consultancies"
        ? fcaGateWay.get(`${serviceEndpoints.projectEndPoints.getAllConsultanciesDropdown}/${level}_dropdown`)
        : level === "asset_survey_templates"
        ? fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getTemplatesDropdown}`, { params })
        : level === "regions"
        ? fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.regionsByClient}/${params.client_id}/regions`)
        : level === "sites"
        ? fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.regions}/${params.region_id}/sites`, { params: searchParam })
        : level === "buildings"
        ? // ? fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.sites}/${params.site_id}/buildings`)
          fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.sites}/${params.site_id}/buildings_dropdown`, { params: searchParam })
        : level === "additions"
        ? fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.buildings}/${params.building_id}/additions`)
        : level === "floors"
        ? fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.buildings}/${params.building_id}/floors`)
        : level === "surveyors"
        ? fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyorsDropdown}`, { params })
        : fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown[level]}`, { params });

export const addSurveyData = params => fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.surveyProject}`, params);

export const addReason = params => fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.getReasonsById}`, params);

export const updateSurveyData = (id, params) => fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.surveyProject}/${id}`, params);

export const updateSurveyAssetData = (id, params) => fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyAssets}/${id}`, params);

export const getAssetprojectSurveys = (params, isReport) => {
    let responseTypes = {};
    if (isReport) {
        responseTypes = { responseType: "blob" };
    }

    return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyProjectlist}`, { params, ...responseTypes });
};

export const getSurveyAssets = (params, isReport) => {
    let responseTypes = {};
    if (isReport) {
        responseTypes = { responseType: "blob" };
    }
    return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyAssets}`, { params, ...responseTypes });
};

export const getInaccessibleSpaceList = (params, isExport = false) => {
    let responseTypes = {};
    if (isExport) {
        responseTypes = { responseType: "blob" };
    }
    return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getInaccessibleSpaceList}`, { params, ...responseTypes });
};

export const deleteAssetSurveyProject = id => fcaFastApi.delete(`${serviceEndpoints.assetSurveyProjectsEndPoints.surveyProject}/${id}`);

export const getAsseetSurveyProjectById = id => fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.surveyProject}/${id}`);

export const getSurveyAssetById = id => fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyAssets}/${id}`);

export const getInaccessibleSpaceById = id => fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getInaccessibleSpaceList}/${id}`);

export const getSurveyAssetImagesById = (id, subTab) =>
    subTab === "inaccessibleSpaceImages" || subTab === "inaccessibleSpaceInfo"
        ? fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getInaccessibleSpaceImagesById}/${id}`)
        : fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyAssetImagesById}/${id}`);

export const getAssetSignature = (entityType, entityId) =>
    fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSignature}/${entityType}/${entityId}`);

export const getSurveyRecommendationImagesById = (id, params) =>
    fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyRecommendationImagesById}/${id}`, { params });

export const getListForAssetSurveyProjectsFilter = params =>
    fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyProjectlist}`, {
        params
    });

export const getListForSurveyAssetsFilter = (params, isInaccessible) =>
    !isInaccessible
        ? fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getListForSurveyAssetsFilter}/`, {
              params
          })
        : fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getListForInaccessibleAssetsFilter}/`, {
              params
          });

export const getAllDataLogs = (params, mobileLog) => {
    if (mobileLog) return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints?.getActivityLog}/mobile`, { params });
    else return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints?.getActivityLog}`, { params });
};

export const getReasonsById = params => fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints?.getReasonsById}`, { params });

export const reviewedAssetsCount = (id, isAssetMngView, params) =>
    isAssetMngView
        ? fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints?.reviewedAssetsCount}/client/${id}`, { params })
        : fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints?.reviewedAssetsCount}/${id}`);

export const transferReviewedAssets = (id, params, isAssetMngView) =>
    isAssetMngView
        ? fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints?.transferReviewedAssets}/client/${id}`, { params })
        : fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints?.transferReviewedAssets}/${id}`, { params });

export const completedAssetsCount = id => fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints?.completedAssetsCount}/${id}`);

export const getSurveyNotesById = id => fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyNotesById}/${id}`);

export const updateInaccessibleSpaceSettings = params =>
    fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.updateInaccessibleSpaceSettings}`, params);

export const updateSurveyAssetFields = (id, params, isInaccessible, source) => {
    if (source === "line_edit") {
        return fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.lineEditSurveyAsset}/${id}`, params);
    }
    return !isInaccessible
        ? fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.updateSurveyAssetFields}/${id}`, params)
        : fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.updateInaccessibleAssetFields}/${id}`, params);
};

export const updateAssetImageComment = (id, params) =>
    fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.updateAssetImageComment}/${id}`, params);

export const activityLogRestore = id => fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.getActivityLog}/${id}`);

export const getSurveyAssetsCommonDataByIds = params =>
    fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyAssetsCommonDataByIds}`, params);

export const handleMultiAssetUpdate = params => fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.handleMultiAssetUpdate}`, params);

export const getAllSurveyAssetIds = params => fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getAllSurveyAssetIds}`, { params });

export const getSurveyorDropdown = params => fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyProjectlist}`, { params });

export const getAssetVoiceNotes = (id, params) =>
    fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getAssetVoiceNotes}/${id}`, { params });

export const deleteVoiceNoteById = id => fcaFastApi.delete(`${serviceEndpoints.assetSurveyProjectsEndPoints.deleteVoiceNoteById}/${id}`);

export const getAssetSurveyFilterDropdown = params =>
    fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getAssetSurveyFilterDropdown}/`, { params });

export const getAssetSurveyUniformatDropdown = params =>
    fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getAssetSurveyUniformatDropdown}`, { params });

export const updateSurveyAssetImageGlobal = (data, isRecommendation = false) =>
    fcaFastApi.patch(
        isRecommendation
            ? `${serviceEndpoints.assetSurveyProjectsEndPoints.updateSurveyRecommendationImageGlobal}`
            : `${serviceEndpoints.assetSurveyProjectsEndPoints.updateSurveyAssetImageGlobal}`,
        data
    );

export const getSuggestionDropdownByClient = id =>
    fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSuggestionDropdownByClient}/${id}/`);

export const defaultImageUpdate = (imageId, id, isRecom, isInaccessible, params) =>
    isRecom
        ? fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.defaultImageUpdate}/recommendations/default_image/${imageId}`, {
              mobile_recom_id: id,
              ...params
          })
        : fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.defaultImageUpdate}/asset/default_image/${imageId}`, {
              mobile_image: true,
              mobile_asset_id: id,
              ...(isInaccessible && { mobile_asset_type: "inaccessible_asset" })
          });

export const handleDelete = (params, isRecom, type) =>
    isRecom
        ? fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.defaultImageUpdate}/recommendations/image/delete`, params)
        : type === "client-standards"
        ? fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.clientStandardImageUpdate}/images`, params)
        : type === "uniformat-standard_images"
        ? fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.uniformatImageImageUpdate}/images`, params)
        : fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.defaultImageUpdate}/asset/image/delete`, params);

export const runWellsFargoScript = params => fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.runWellsFargoScript}`, params);

export const searchAndReplace = params => fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.searchAndReplace}`, params);

export const findAssetsBeforeReplace = params => fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.searchAndReplace}`, params);

export const getTableSummaryData = params => {
    return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyAssets}/mobile-asset/summary/`, { params });
};

export const revertAsset = id => {
    return fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.revertAsset}/${id}`);
};

export const getClientStandardList = (params, isExport) => {
    let responseTypes = {};
    if (isExport) {
        responseTypes = { responseType: "blob" };
    }
    return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getClientStandardList}`, { params, ...responseTypes });
};

export const getSyncedData = (type, param) => {
    if (type === "sync-asset") return fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSyncedAssetsData}${param}`);
    else if (type === "sync-uniformat-level")
        return fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSyncedUniformatLevelData}`, param);
    else return fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSyncedClientStandardData}`, param);
};
export const updateSurveyClientDeliverable = (id, params) => {
    return fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.updateSurveyClientDeliverable}/${id}`, params);
};

export const getClientDeliverableList = (params, isExport = false) => {
    let responseTypes = {};
    if (isExport) {
        responseTypes = { responseType: "blob" };
    }
    return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getClientDeliverableList}`, { params, ...responseTypes });
};

export const getUniformatLevelList = (params, isExport = false) => {
    let responseTypes = {};
    if (isExport) {
        responseTypes = { responseType: "blob" };
    }
    return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getUniformatLevelList}`, { params, ...responseTypes });
};
export const getDropdownListForStandards = (type, params) => {
    if (type === "client-standard-templates") {
        return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getClientStandardList}`, { params });
    } else {
        return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getUniformatDropdown}`, { params });
    }
};

export const updateSurveyStandard = (id, params, type) => {
    if (type === "client-standard-templates") {
        return fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.updateSurveyClientStandard}/${id}`, params);
    } else {
        return fcaFastApi.put(`${serviceEndpoints.assetSurveyProjectsEndPoints.updateSurveyUniformatLevel}/${id}`, params);
    }
};

export const getSurveyStandardById = (id, type) => {
    if (type === "client-standard-templates") {
        return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyClientStandardById}/${id}`);
    } else {
        return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyUniformatLevelById}/${id}`);
    }
};

export const getStandardImagesById = (id, type, params) => {
    if (type === "global-standard-image") {
        return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getGlobalStandardImage}/${id}`);
    }
    if (type === "global-uniformat-image") return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getGlobalUniformatImage}/${id}`,{params});
    if (type === "survey-uniformat-image") return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyUniformatImage}/${id}`,{params});
    else return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getSurveyStandardImage}/${id}`);
};

export const getAiAnalyseData = params => {
    return fcaReportGateway.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getAiAnalyseData}`, { params });
};

export const postAiAnalyse = params => fcaReportGateway.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.postAiAnalyse}`, params);
export const clearAiAnalyse = params => fcaReportGateway.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.clearAiAnalyse}`, params);
export const patchAiAnalyse = params => {
    return fcaReportGateway.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.patchAiAnalyse}`, params);
};

export const getSelectAllStandardList = (type, params) => {
    if (type === "client-standard-templates") {
        return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getClientStandardList}`, { params });
    } else {
        return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getUniformatDropdown}`, { params });
    }
};

export const getListForSurveyor = params => {
    return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getListForSurveyor}`, { params });
};
export const groupSurveyUpdate = params => {
    return fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.groupSurveyUpdate}`, params);
};

export const saveAiAnalyseAssetData = params =>
    fcaReportGateway.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.saveAiAnalyseAssetData}`, params);

export const getAiAnalyseKey = params => {
    return fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.getAiAnalyseKey}`, { params });
};

export const getEntityDropdown = params => {
    return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getEntityDropdown}`, { params });
};

export const getGroupEditProgress = (id, params) => {
    return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.getGroupEditProgress}${id}`, { params });
};
export const revertAssetDataById = id => {
    return fcaFastApi.get(`${serviceEndpoints.assetSurveyProjectsEndPoints.revertAssetDataById}/${id}`);
};
